import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useLocation, useNavigate } from "react-router-dom";
import { Orb } from "@/components/hara/Kit";

const HIDDEN = ["/staff", "/summary", "/hara", "/bioq"];
export const fabVisible = (pathname) => pathname !== "/" && pathname !== "/menu/all" && !HIDDEN.some((p) => pathname.startsWith(p));

// Orb-only floating Bio-Q button (60px); "Ask Bio-Q" appears once per session as a short-lived tooltip.
export const FloatingHara = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [tip, setTip] = useState(false);
  const show = fabVisible(pathname);
  useEffect(() => {
    if (!show || sessionStorage.getItem("z6_bioq_tip")) return undefined;
    sessionStorage.setItem("z6_bioq_tip", "1");
    setTip(true);
    const t = setTimeout(() => setTip(false), 3500);
    return () => clearTimeout(t);
  }, [show]);
  if (!show) return null;
  return (
    <div data-fab className="fixed bottom-5 right-5 z-40 sm:bottom-6 sm:right-6">
      <AnimatePresence>
        {tip && (
          <motion.span data-testid="floating-hara-tip" role="status" initial={{ opacity: 0, x: 8 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: 8 }}
            className="font-ui absolute right-[72px] top-1/2 -translate-y-1/2 whitespace-nowrap rounded-full bg-[#0B2E44] px-4 py-2 text-[15px] font-normal text-white">Ask Bio-Q</motion.span>
        )}
      </AnimatePresence>
      <motion.button data-testid="floating-hara-btn" onClick={() => navigate("/bioq")} aria-label="Ask Bio-Q, your waiter"
        initial={{ scale: 0, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} transition={{ type: "spring", stiffness: 200, damping: 16, delay: 0.6 }}
        whileTap={{ scale: 0.9 }} className="flex h-[60px] w-[60px] items-center justify-center rounded-full bg-white/90 ring-1 ring-[#0B2E44]/15 backdrop-blur-md">
        <Orb size="sm" />
      </motion.button>
    </div>
  );
};
